<template>
  <div class="header-index-warp">
    <van-nav-bar title="标题">
      <template #left>
        <img src="@/assets/image/back.png" alt @click="onClickLeft" />
      </template>
      <template #title>
        <div class="center">
          <p>{{titleName}}</p>
        </div>
      </template>
      <template #right>
        <img
          :src="$theme.assist_icon_add_default"
          alt
          v-if="showRightIcon"
          @click="showMask=!showMask;"
        />
        <span class="btn" v-if="showRightBtn">确定</span>
      </template>
    </van-nav-bar>
    <van-overlay :show="showMask" @click="showMask = false">
      <div class="showMask" v-show="showMask" @click.stop>
        <p @click="jumpactivityDetails('add')">新增</p>
        <p @click="jumpactivityDetails('trial')">试算</p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import utils from "@/utils/common";
import { Dialog } from 'vant';
export default {
  data() {
    return {
      showMask: false,
    };
  },
  props: {
    titleName: {
      default: "满折满减列表",
      type: String,
    },
    showRightIcon: {
      default: true,
      type: Boolean,
    },
    showRightBtn: {
      default: false,
      type: Boolean,
    },
    beeType: {
      default: 1,
      type: Number,
    },
    brandData: {
      default: function () {
        return {};
      },
      type: Object,
    },
    branchStatusItem: {
      default: 'OPENING',
      type: String,
    },
    branchStatus: {
      default: 'OPENING',
      type: String,
    }
  },
  methods: {
    onClickLeft() {
      utils.goBack();
    },
    jumpactivityDetails(item) {
      console.log(this.branchStatusItem);
      if (this.branchStatusItem == 'FREEZE' || this.branchStatus == 'FREEZE') {
        Dialog.confirm({
          message: '店铺已冻结，无法操作',
          confirmButtonText: '我知道了',
          confirmButtonColor: '#007AFF',
          showCancelButton: false
        })
        return
      }
      let url;
      switch (item) {
        case "trial":
          url = window.location.origin + "/h5user/discount_trial?type=1";
          if (this.beeType == 2) {
            if (this.brandData.shopId) {
              url = url + "&brandId=" + this.brandData.shopId;
            } else {
              return this.$toast("请先选择品牌");
            }
          }
          utils.jumpToNewPage({ url: url });
          this.showMask = !this.showMask
          break;
        case "add":
          url = window.location.origin + "/h5user/discount";
          if (this.beeType == 2 && !this.brandData.shopId) {
            return this.$toast("请先选择品牌");
          }
          this.$emit('add')
          this.showMask = !this.showMask
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-index-warp {
  position: relative;
  display: block;
  .van-overlay {
    top: 90px;
    background: none;
  }
  .showMask {
    background: url("../../../assets/wanning/headerico.png");
    width: 173px;
    height: 167px;
    position: absolute;
    right: 10px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    z-index: 99;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 26px;
      color: #fff;
      font-weight: 500;
      padding: 15px;
    }
    .activep {
      color: #999;
    }
  }
  .van-nav-bar__left {
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      display: block;
    }
  }
  .van-nav-bar__title {
    font-size: 32px;
    color: #333;
    font-weight: 500;
    .center {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 44px;
        height: 44px;
        display: block;
        object-fit: cover;
      }
    }
  }
  .van-nav-bar__right {
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      display: block;
    }
    .btn {
      background-color: var(--epButtonColor);
      color: var(--epTextColor);
      font-size: 24px;
      text-align: center;
      width: 140px;
      padding: 9px 0;
      border-radius: 50px;
    }
  }
}
</style>